import { DateTime, Duration } from 'luxon';

import { loadLuxonDateTime } from '@rygen/rygen-ui/util';

import { WaterfallTenderRateQuote } from './WaterfallTenderRateQuote';
import { WaterfallTenderStatus } from './WaterfallTenderStatus';

export class WaterfallTender {
  id: number;
  shipmentId: number;
  rateShopId: number;
  status: WaterfallTenderStatus;
  tenderTimeoutDuration: Duration;
  quotes: WaterfallTenderRateQuote[] = [];
  active: boolean = true;
  createdBy: string;
  createdDate: DateTime;

  constructor(opts: WaterfallTender) {
    this.id = opts.id;
    this.shipmentId = opts.shipmentId;
    this.rateShopId = opts.rateShopId;

    if (typeof opts?.status === 'string') {
      this.status = WaterfallTenderStatus[opts.status];
    } else {
      this.status = opts.status;
    }

    if (typeof opts.tenderTimeoutDuration === 'string') {
      this.tenderTimeoutDuration = Duration.fromISO(opts.tenderTimeoutDuration);
    } else {
      this.tenderTimeoutDuration = opts.tenderTimeoutDuration;
    }

    this.quotes = opts.quotes.map((val) => new WaterfallTenderRateQuote(val));
    this.quotes.sort((a, b) => a.sequenceNumber - b.sequenceNumber);

    this.active = opts.active;

    this.createdBy = opts.createdBy;
    this.createdDate = loadLuxonDateTime(opts.createdDate) ?? DateTime.now();
  }

  isCanceled(): boolean {
    return this.status === WaterfallTenderStatus.CANCELED;
  }

  isComplete(): boolean {
    return (
      this.status === WaterfallTenderStatus.COMPLETED_SUCCESSFULLY ||
      this.status ===
        WaterfallTenderStatus.COMPLETED_WITHOUT_ACCEPTED_RATE_QUOTE
    );
  }

  isFinalized(): boolean {
    return this.isComplete() || this.isCanceled();
  }

  isInProgress(): boolean {
    return !this.isFinalized() && !this.isCanceled();
  }
}
